require('./tomselect-checkboxes'); // the fx_checkbox_untabbable TomSelect plugin

if (document.querySelector(".settings")) {
    document.querySelectorAll('.multi-select-box .select-users-email').forEach(select => {
        new TomSelect(select, {
            maxItems: null,
            plugins: {
                'checkbox_options': {
                    'checkedClassNames':   ['ts-checked'],
                    'uncheckedClassNames': ['ts-unchecked'],
                },
                'fx_checkbox_untabbable': {}, // (after checkbox_options: Tab leaves the field)
            },
            allowEmptyOption: true,
        });
    });
}
